import {
  RouteLocationNormalized,
  RouteRecordRaw,
  createRouter,
  createWebHashHistory
} from 'vue-router'
import useUserStore from '@stores/userStore'
import { RIGHTS } from '@interfaces/RightsEnum'

import UserDetails from '@components/UserDetails.vue'
import { isNil } from 'ramda'
const FacturationComp = () => import('@components/FacturationComp.vue')
const UserRecord = () => import('@components/UserRecord.vue')
const UserList = () => import('@components/UserList.vue')
const NewUser = () => import('@components/NewUser.vue')
const UserRights = () => import('@components/UserRights.vue')
const PsapUsers = () => import('@components/PsapUsers.vue')
const NewOperator = () => import('@components/Operator/NewOperator.vue')
const PsapMep = () => import('@components/PsapMep.vue')
const OperatorDetails = () => import('@components/Operator/OperatorDetails.vue')
const OperatorUsers = () => import('@components/OperatorUsers.vue')
const OperatorList = () => import('@components/Operator/OperatorList.vue')
const AuthentN = () => import('@pages/AuthentN.vue')
const AuthZ = () => import('@pages/AuthZ.vue')
const MonthlyStatistics = () => import('@components/MonthlyStatistics.vue')
const PsapDetails = () => import('@components/PsapDetails.vue')
const WelcomeComponent = () => import('@components/WelcomeComponent.vue')
const FaqFr = () => import('@components/faq/FaqFr.vue')
const DocGuide = () => import('@components/faq/DocGuide.vue')
const OperatorRecord = () => import('@components/Operator/OperatorRecord.vue')
const PsapToAttachList = () => import('@components/PsapToAttachList.vue')
const PsapRecord = () => import('@components/PsapRecord.vue')
const AttachMyPsap = () => import('@components/AttachMyPsap.vue')
const PsapRecevability = () => import('@components/PsapRecevability.vue')
const SupportIncident = () => import('@components/faq/SupportIncident.vue')
const LogsList = () => import('@components/LogsList.vue')
const OperatorRecevability = () =>
  import('@components/OperatorRecevability.vue')
const OperatorRecevabilityStepGetAddressTestWaiting = () =>
  import(
    '@components/OperatorRecevabilityStep/OperatorRecevabilityStepGetAddressTestWaiting.vue'
  )
const OperatorRecevabilityStepGetLocationSvhTestWaiting = () =>
  import(
    '@components/OperatorRecevabilityStep/OperatorRecevabilityStepGetLocationSvhTestWaiting.vue'
  )
const OperatorRecevabilityStepPushLocationTestWaiting = () =>
  import(
    '@components/OperatorRecevabilityStep/OperatorRecevabilityStepPushLocationTestWaiting.vue'
  )
const OperatorRecevabilityStepPushLocationSvhTestWaiting = () =>
  import(
    '@components/OperatorRecevabilityStep/OperatorRecevabilityStepPushLocationSvhTestWaiting.vue'
  )
const OperatorRecevabilityStepRecevabilityAgreementApnf = () =>
  import(
    '@components/OperatorRecevabilityStep/OperatorRecevabilityStepRecevabilityAgreementApnf.vue'
  )
const OperatorRecevabilityStepRecevabilityAgreementWorldline = () =>
  import(
    '@components/OperatorRecevabilityStep/OperatorRecevabilityStepRecevabilityAgreementWorldline.vue'
  )
const PsapRecevabilityStepWaitingInfosSsl = () =>
  import(
    '@components/PsapRecevabilityStep/PsapRecevabilityStepWaitingInfosSsl.vue'
  )
const PsapRecevabilityStepWaitingCguValidationSVH = () =>
  import(
    '@components/PsapRecevabilityStepSvh/PsapRecevabilityStepWaitingCguValidationSVH.vue'
  )
const PsapRecevabilityStepWaitingInfosSslSvh = () =>
  import(
    '@components/PsapRecevabilityStepSvh/PsapRecevabilityStepWaitingInfosSslSvh.vue'
  )

const PsapRecevabilityStepTerminalLocalisationPullSvhTestSvh = () =>
  import(
    '@components/PsapRecevabilityStepSvh/PsapRecevabilityStepTerminalLocalisationPullSvhTestSvh.vue'
  )

const PsapRecevabilityStepTerminalLocationPushTestSvh = () =>
  import(
    '@components/PsapRecevabilityStepSvh/PsapRecevabilityStepTerminalLocationPushTestSvh.vue'
  )

const PsapRecevabilityStepTerminalLocationPullTestSvh = () =>
  import(
    '@components/PsapRecevabilityStepSvh/PsapRecevabilityStepTerminalLocationPullTestSvh.vue'
  )

const PsapRecevabilityStepRecevabilityAgreementApnfSvh = () =>
  import(
    '@components/PsapRecevabilityStepSvh/PsapRecevabilityStepRecevabilityAgreementApnfSvh.vue'
  )

const PsapRecevabilityStepGoingIntoProductionSvh = () =>
  import(
    '@components/PsapRecevabilityStepSvh/PsapRecevabilityStepGoingIntoProductionSvh.vue'
  )

const EventList = () => import('@components/EventList.vue')

const OperatorMaintenance = () =>
  import('@components/Operator/OperatorMaintenance.vue')

const NewEvent = () => import('@components/NewEvent.vue')
const EditEvent = () => import('@components/EditEvent.vue')
const PsapList = () => import('@components/PsapList.vue')
const PsapRecevabilitySvh = () => import('@components/PsapRecevabilitySvh.vue')
const PsapRecevabilityStepWaitingCguValidation = () =>
  import(
    '@components/PsapRecevabilityStep/PsapRecevabilityStepWaitingCguValidation.vue'
  )
const PsapRecevabilityStepConfigSsl = () =>
  import('@components/PsapRecevabilityStep/PsapRecevabilityStepConfigSsl.vue')
const PsapRecevabilityStepTerminalLocationPushTest = () =>
  import(
    '@components/PsapRecevabilityStep/PsapRecevabilityStepTerminalLocationPushTest.vue'
  )

const PsapRecevabilityStepTerminalLocationPullTest = () =>
  import(
    '@components/PsapRecevabilityStep/PsapRecevabilityStepTerminalLocationPullTest.vue'
  )

const PsapRecevabilityStepAgreementWorldline = () =>
  import(
    '@components/PsapRecevabilityStep/PsapRecevabilityStepAgreementWorldline.vue'
  )
const PsapRecevabilityStepAgreementApnf = () =>
  import(
    '@components/PsapRecevabilityStep/PsapRecevabilityStepAgreementApnf.vue'
  )
const RefreshCacheCnForPull = () =>
  import('@components/RefreshCacheCnForPull.vue')
const psapRecevabilitySteps = [
  {
    path: 'WAITING_CGU_VALIDATION',
    component: PsapRecevabilityStepWaitingCguValidation,
    meta: {
      rights: [RIGHTS.RECEVABILITY_PSAP_WAITING_CGU_VALIDATION],
      psapRecevabilityStage: 'WAITING_CGU_VALIDATION'
    }
  },
  {
    path: 'WAITING_INFOS_SSL',
    component: PsapRecevabilityStepWaitingInfosSsl,
    meta: {
      rights: [RIGHTS.RECEVABILITY_PSAP_WAITING_INFOS_SSL],
      psapRecevabilityStage: 'WAITING_INFOS_SSL'
    }
  },
  {
    path: 'CONFIG_SSL',
    component: PsapRecevabilityStepConfigSsl,
    meta: {
      rights: [RIGHTS.RECEVABILITY_PSAP_CONFIG_SSL],
      psapRecevabilityStage: 'CONFIG_SSL'
    }
  },
  {
    path: 'TERMINAL_LOCATION_PUSH_TEST',
    component: PsapRecevabilityStepTerminalLocationPushTest,
    meta: {
      rights: [RIGHTS.RECEVABILITY_PSAP_TERMINAL_LOCATION_PUSH_TEST],
      psapRecevabilityStage: 'TERMINAL_LOCATION_PUSH_TEST'
    }
  },
  {
    path: 'TERMINAL_LOCATION_PULL_TEST',
    component: PsapRecevabilityStepTerminalLocationPullTest,
    meta: {
      rights: [RIGHTS.RECEVABILITY_PSAP_TERMINAL_LOCATION_PULL_TEST],
      psapRecevabilityStage: 'TERMINAL_LOCATION_PULL_TEST'
    }
  },
  {
    path: 'RECEVABILITY_AGREEMENT_WORLDLINE',
    component: PsapRecevabilityStepAgreementWorldline,
    meta: {
      rights: [RIGHTS.RECEVABILITY_PSAP_AGREEMENT_WORLDLINE],
      psapRecevabilityStage: 'RECEVABILITY_AGREEMENT_WORLDLINE'
    }
  },
  {
    path: 'RECEVABILITY_AGREEMENT_APNF',
    component: PsapRecevabilityStepAgreementApnf,
    meta: {
      rights: [RIGHTS.RECEVABILITY_PSAP_AGREEMENT_APNF],
      psapRecevabilityStage: 'RECEVABILITY_AGREEMENT_APNF'
    }
  }
]

const psapRecevabilitySvhSteps = [
  {
    path: 'WAITING_CGU_VALIDATION',
    component: PsapRecevabilityStepWaitingCguValidationSVH,
    meta: {
      rights: [RIGHTS.RECEVABILITY_PSAP_WAITING_CGU_VALIDATION],
      psapRecevabilityStage: 'WAITING_CGU_VALIDATION'
    }
  },
  {
    path: 'WAITING_INFOS_SSL',
    component: PsapRecevabilityStepWaitingInfosSslSvh,
    meta: {
      rights: [RIGHTS.RECEVABILITY_PSAP_WAITING_INFOS_SSL],
      psapRecevabilityStage: 'WAITING_INFOS_SSL'
    }
  },
  {
    path: 'TERMINAL_LOCALISATION_PULL_SVH_TEST',
    component: PsapRecevabilityStepTerminalLocalisationPullSvhTestSvh,
    meta: {
      rights: [RIGHTS.RECEVABILITY_PSAP_TERMINAL_LOCALISATION_PULL_SVH_TEST],
      psapRecevabilityStage: 'TERMINAL_LOCALISATION_PULL_SVH_TEST'
    }
  },
  {
    path: 'TERMINAL_LOCATION_PUSH_TEST',
    component: PsapRecevabilityStepTerminalLocationPushTestSvh,
    meta: {
      rights: [RIGHTS.RECEVABILITY_PSAP_TERMINAL_LOCATION_PUSH_TEST],
      psapRecevabilityStage: 'TERMINAL_LOCATION_PUSH_TEST'
    }
  },
  {
    path: 'TERMINAL_LOCATION_PULL_TEST',
    component: PsapRecevabilityStepTerminalLocationPullTestSvh,
    meta: {
      rights: [RIGHTS.RECEVABILITY_PSAP_TERMINAL_LOCATION_PULL_TEST],
      psapRecevabilityStage: 'TERMINAL_LOCATION_PULL_TEST'
    }
  },
  {
    path: 'RECEVABILITY_AGREEMENT_APNF',
    component: PsapRecevabilityStepRecevabilityAgreementApnfSvh,
    meta: {
      rights: [RIGHTS.RECEVABILITY_PSAP_AGREEMENT_APNF],
      psapRecevabilityStage: 'RECEVABILITY_AGREEMENT_APNF'
    }
  },
  {
    path: 'GOING_INTO_PRODUCTION',
    component: PsapRecevabilityStepGoingIntoProductionSvh,
    meta: {
      rights: [RIGHTS.RECEVABILITY_PSAP_GOING_INTO_PRODUCTION],
      psapRecevabilityStage: 'GOING_INTO_PRODUCTION'
    }
  }
]

const routes: RouteRecordRaw[] = [
  {
    path: '/authent',
    name: 'authent',
    component: AuthentN
  },
  {
    path: '/',
    name: 'authentZ',
    component: AuthZ,
    beforeEnter: (to, from, next) => {
      const userStore = useUserStore()
      if (userStore.getToken) {
        next()
      } else {
        next('/authent')
      }
    },
    redirect: '/home',
    children: [
      {
        path: 'home',
        name: 'welcome',
        component: WelcomeComponent
      },
      {
        path: 'faq',
        name: 'faq-fr',
        component: FaqFr
      },

      {
        path: 'refreshCacheCnForPull',
        name: 'refresh-cache-cn-for-pull',
        component: RefreshCacheCnForPull
      },
      {
        path: '/docGuide',
        name: 'doc-guide',
        component: DocGuide
      },
      {
        path: '/my-operator-detail',
        children: [
          {
            path: 'infos',
            name: 'operator-detail-info',
            component: OperatorRecord,
            meta: { himSelfConsult: true }
          },
          {
            path: 'users',
            name: 'operator-detail-users',
            component: OperatorUsers,
            meta: { himSelfConsult: true }
          }
        ]
      },
      {
        path: '/user-detail/:id',
        component: UserDetails,
        children: [
          {
            path: 'record',
            component: UserRecord
          },
          {
            path: 'rights',
            component: UserRights
          }
        ]
      },
      {
        path: '/my-psap-detail',
        name: 'my-psap-detail',
        children: [
          {
            path: 'infos',
            name: 'psap-detail-infos',
            component: PsapRecord,
            meta: { himSelfConsult: true }
          },
          {
            path: 'users',
            name: 'psap-detail-users',
            component: PsapUsers,
            meta: { himSelfConsult: true }
          }
        ]
      },
      {
        path: '/NewUser',
        name: 'new-user',
        component: NewUser
      },
      {
        path: '/operatorMaintenance',
        name: 'operator-maintenance',
        component: OperatorMaintenance
      },
      {
        path: '/my-profile',
        component: UserDetails,
        children: [
          {
            path: 'record',
            component: UserRecord,
            meta: { himSelfConsult: true }
          },
          {
            path: 'rights',
            component: UserRights,
            meta: { himSelfConsult: true }
          }
        ]
      },
      {
        path: '/attach-my-psap',
        name: 'attach-my-psap',
        component: AttachMyPsap
      },
      {
        path: '/my-psap-recevability',
        name: 'my-psap-recevability',
        component: PsapRecevability,
        children: psapRecevabilitySteps
      },
      {
        path: '/my-operator-recevability',
        component: OperatorRecevability,
        children: [
          {
            path: 'GETADDRESS_TEST_WAITING',
            name: 'get-address-test-waiting',
            component: OperatorRecevabilityStepGetAddressTestWaiting
          },
          {
            path: 'GETLOCATIONSVH_TEST_WAITING',
            name: 'get-location-svh-test-waiting',
            component: OperatorRecevabilityStepGetLocationSvhTestWaiting
          },
          {
            path: 'PUSHLOCATION_TEST_WAITING',
            name: 'push-location-test-waiting',
            component: OperatorRecevabilityStepPushLocationTestWaiting
          },
          {
            path: 'PUSHLOCATIONSVH_TEST_WAITING',
            name: 'push-location-svh-test-waiting',
            component: OperatorRecevabilityStepPushLocationSvhTestWaiting
          },
          {
            path: 'RECEVABILITY_AGREEMENT_APNF',
            name: 'recevability-agreement-apnf',
            component: OperatorRecevabilityStepRecevabilityAgreementApnf
          },
          {
            path: 'RECEVABILITY_AGREEMENT_WORLDLINE',
            name: 'recevability-agreement-worldline',
            component: OperatorRecevabilityStepRecevabilityAgreementWorldline
          }
        ]
      },
      {
        path: '/faq',
        name: 'faq-fr',
        component: FaqFr
      },
      {
        path: '/userList',
        children: [
          {
            path: 'integrators',
            component: UserList
          },
          {
            path: 'ministerManagers',
            component: UserList
          },
          {
            path: 'stateAuthority',
            component: UserList
          },
          {
            path: 'all',
            component: UserList
          }
        ]
      },
      {
        path: '/NewOperator',
        name: 'new-operator',
        component: NewOperator
      },
      {
        path: '/operator-detail/:id',
        component: OperatorDetails,
        children: [
          {
            path: 'record',
            component: OperatorRecord
          },
          {
            path: 'users',
            component: OperatorUsers
          }
        ]
      },
      {
        path: '/psap-detail/:id',
        component: PsapDetails,
        children: [
          {
            path: 'record',
            component: PsapRecord
          },
          {
            path: 'users',
            component: PsapUsers
          }
        ]
      },
      {
        path: '/psapList/:list',
        component: PsapList
      },
      {
        path: '/operatorList',
        name: 'operator-list',
        component: OperatorList
      },
      {
        path: '/factu',
        name: 'facturation',
        component: FacturationComp
      },
      {
        path: '/psap-recevability/:id',
        component: PsapRecevability,
        children: psapRecevabilitySteps
      },
      {
        path: '/psap-recevability-svh/:id',
        component: PsapRecevabilitySvh,
        children: psapRecevabilitySvhSteps
      },
      {
        path: '/operator-recevability/:id',
        component: OperatorRecevability,
        children: [
          {
            path: 'GETADDRESS_TEST_WAITING',
            name: 'get-address-test-waiting',
            component: OperatorRecevabilityStepGetAddressTestWaiting,
            meta: {
              rights: [RIGHTS.RECEVABILITY_OPERATOR_GETADDRESS_TEST_WAITING],
              operatorRecevabilityStage: 'GETADDRESS_TEST_WAITING'
            }
          },
          {
            path: 'GETLOCATIONSVH_TEST_WAITING',
            name: 'get-location-svh-test-waiting',
            component: OperatorRecevabilityStepGetLocationSvhTestWaiting,
            meta: {
              rights: [
                RIGHTS.RECEVABILITY_OPERATOR_GETLOCATIONSVH_TEST_WAITING
              ],
              operatorRecevabilityStage: 'GETLOCATIONSVH_TEST_WAITING'
            }
          },
          {
            path: 'PUSHLOCATION_TEST_WAITING',
            name: 'push-location-test-waiting',
            component: OperatorRecevabilityStepPushLocationTestWaiting,
            meta: {
              rights: [RIGHTS.RECEVABILITY_OPERATOR_PUSHLOCATION_TEST_WAITING],
              operatorRecevabilityStage: 'PUSHLOCATION_TEST_WAITING'
            }
          },
          {
            path: 'PUSHLOCATIONSVH_TEST_WAITING',
            name: 'push-location-svh-test-waiting',
            component: OperatorRecevabilityStepPushLocationSvhTestWaiting,
            meta: {
              rights: [
                RIGHTS.RECEVABILITY_OPERATOR_PUSHLOCATIONSVH_TEST_WAITING
              ],
              operatorRecevabilityStage: 'PUSHLOCATIONSVH_TEST_WAITING'
            }
          },
          {
            path: 'RECEVABILITY_AGREEMENT_APNF',
            name: 'recevability-agreement-apnf',
            component: OperatorRecevabilityStepRecevabilityAgreementApnf,
            meta: {
              rights: [RIGHTS.RECEVABILITY_OPERATOR_AGREEMENT_APNF],
              operatorRecevabilityStage: 'RECEVABILITY_AGREEMENT_APNF'
            }
          },
          {
            path: 'RECEVABILITY_AGREEMENT_WORLDLINE',
            name: 'recevability-agreement-worldline',
            component: OperatorRecevabilityStepRecevabilityAgreementWorldline,
            meta: {
              rights: [RIGHTS.RECEVABILITY_OPERATOR_AGREEMENT_WORLDLINE],
              operatorRecevabilityStage: 'RECEVABILITY_AGREEMENT_WORLDLINE'
            }
          }
        ]
      },
      {
        path: '/supportIncident',
        component: SupportIncident
      },
      {
        path: '/logsList',
        component: LogsList
      },
      {
        path: '/monthly-statistics',
        name: 'monthly_statistics',
        component: MonthlyStatistics
      },
      {
        path: '/psapMep',
        component: PsapMep
      },
      {
        path: '/psapToAttachList',
        name: 'psap-attach-list',
        component: PsapToAttachList
      },
      {
        path: '/eventList',
        name: 'event-list',
        component: EventList
      },
      {
        path: '/newEvent',
        name: 'new-event',
        component: NewEvent
      },
      {
        path: '/event-detail',
        children: [
          {
            path: ':id/record',
            component: EditEvent
          }
        ]
      }
    ]
  }
]

function checkLoginStatus(
  to: RouteLocationNormalized,
  from: RouteLocationNormalized
) {
  const userStore = useUserStore()

  if (from.path !== to.path) {
    if (!isNil(userStore.getToken)) {
      return true
    } else {
      return { name: 'authent' }
    }
  }
}
const router = createRouter({
  history: createWebHashHistory(),
  routes
})
router.beforeEach(checkLoginStatus)
export default router
